export const TEXTS = {
  LIVE_PROCESSING_TITLE: 'Processing document',
  LIVE_PROCESSING_SUBTITLE: 'I am reading this document. Each step appears below as I reach it.',
  LIVE_FAILED_TITLE: 'Processing failed',
  LIVE_FAILED_SUBTITLE: "I couldn't process this document. The step that failed is marked below.",
};
